const DAY = 24 * 60 * 60 * 1000
const YEAR = 365 * DAY

const getBaseDomain = () => {
  const parts = window.location.hostname.split('.')

  if (parts.length === 1) {
    return parts[0]
  }

  return `.${parts.slice(-2).join('.')}`
}

export const setCookie = () => {
  const expires = new Date(Date.now() + YEAR).toUTCString()
  document.cookie = `cookies=true; expires=${expires}; path=/; domain=${getBaseDomain()}; Secure; SameSite=None`
}
